var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports,"__esModule",{value:true});exports.i18nOptions=void 0;

var _en=_interopRequireDefault(require("@24i/prd-localization-files-prj-cobutv/dist/en.json"));

var i18nOptions={
resources:{
en:{sott:_en.default}

}
};exports.i18nOptions=i18nOptions;